import React, { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';
export default (function () {
  const { data } = useRequest({
    name: 'GET_CRAFT_PARAMS',
    url: `/api/crafts`,
    manual: false,
  });
  // const [newDatas, setNewDatas] = useState([]);
  useEffect(() => {
    //
    if (data && data.length > 0 && data[0].param && data[0].param.length !== 0) {
      // let newDatas_ = [];
      data[0].param.forEach(cdata => {
        cdata.img = (
          <img src={require('@/assets/images/process/' + cdata.icon_url)} alt={cdata.title} />
        );
        if (cdata.name === 'clp_open' || cdata.name === 'inj' || cdata.name === 'hold') {
          cdata.rows.forEach(row => {
            if (row === 'SEGNUMBER') {
              //let seg = cdata.data[cdata.data.length - 1][0].value;

              cdata.rows.splice(-1, 1);
              cdata.param_ids.splice(-1, 1);
              /*  if (seg && 0 < parseInt(seg) < 7) {
                cdata.data.forEach(d => {
                  d.forEach((dd, i) => {
                    if (i < cdata.columns.length - seg) {
                      dd.value = '';
                    }
                  });
                });
              } */
            }
          });
        }
        if (cdata.name === 'clp_cls' || cdata.name === 'charge') {
          cdata.rows.forEach(row => {
            if (row === 'SEGNUMBER') {
              //let seg = cdata.data[cdata.data.length - 1][0].value;

              cdata.rows.splice(-1, 1);
              cdata.param_ids.splice(-1, 1);
              /*  if (seg && 0 < parseInt(seg) < 7) {
                cdata.data.forEach(d => {
                  d.forEach((dd, i) => {
                    if (i >= seg) {
                      dd.value = '';
                    }
                  });
                });
              } */
            }
          });
        }
      });
    }
  }, [data]);

  return data || [];
});
